/**
 * Created by christiancueni on 02/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import cloneDeep from 'lodash-es/cloneDeep';
import {FileAttachment, IFileAttachment} from "../attachment/attachment.model";

export class GroupDetails {
  public static EMPTY = '';
  public static INVALID_ID = -1;

  constructor(public id: number,
              public name: string,
              public displayName: string,
              public school: number,
              public year: number) {
  }

  static initialObject() {
    return new GroupDetails(GroupDetails.INVALID_ID, GroupDetails.EMPTY,
      GroupDetails.EMPTY, GroupDetails.INVALID_ID, GroupDetails.INVALID_ID);
  }
}

export interface Comment {
  author: number;
  authorFullName: string;
  content: string;
  created: string;
  event: number;
  id: number;
}

export interface FormEvent {
  title?: string;
  id?;
  description: string;
  date: Date;
  endDate?: Date;
  group: string;
  start: string;
  duration: string;
  state: string;
  isPrivate: boolean;
  uploads: Object[];
  label: string;
  label_color: string;
  label_title: string;
  recurrences: string | null;
  recurrencesStart?: string;
}

export interface BackendEvent {
  title: string;
  description: string;
  date: string;
  end_date: string;
  group: number;
  group_details: Object;
  row_start: number;
  row_end: number;
  id: number;
  state: string;
  is_private: boolean;
  uploads: IFileAttachment[];
  comments: Comment[];
  label: number;
  label_color: string;
  label_title: string;
  recurrences: string | null;
  recurrences_start: string;
}

export class ViewEvent {
  public static EMPTY = '';
  public static INVALID_ID = -1;

  attachmentObjects = <FileAttachment[]>[];

  constructor(public title: string,
              public description: string,
              public date: string,
              public endDate: string,
              public group: number,
              public row_start: number,
              public row_end: number,
              public id: number,
              public state: string,
              public start: number,
              public duration: number,
              public startClass: string,
              public lengthClass: string,
              public groupDetails: GroupDetails,
              public comments: Comment[],
              public uploads: FileAttachment[],
              public label: number,
              public labelColor: string,
              public labelTitle: string,
              public isPrivate: boolean,
              public recurrences: string | null,
              public recurrences_start: string) {
  }

  static initialObject() {
    return new ViewEvent(ViewEvent.EMPTY, ViewEvent.EMPTY, ViewEvent.EMPTY, ViewEvent.EMPTY,
      ViewEvent.INVALID_ID, ViewEvent.INVALID_ID, ViewEvent.INVALID_ID, ViewEvent.INVALID_ID,
      ViewEvent.EMPTY, ViewEvent.INVALID_ID, ViewEvent.INVALID_ID, ViewEvent.EMPTY,
      ViewEvent.EMPTY, GroupDetails.initialObject(), [], [], ViewEvent.INVALID_ID,
      ViewEvent.EMPTY, ViewEvent.EMPTY, false, null, '');
  }

  static fromBackendEvent(event: BackendEvent, groupDetails: GroupDetails) {
    let duration = event.row_end - event.row_start + 1;
    let startClass = `event--start-${event.row_start}`;
    let lengthClass = `event--length-${duration}`;

    let uploads = event.uploads?.map((upload: IFileAttachment) => {
      return FileAttachment.fromPayload(upload);
    });

    return new ViewEvent(event.title, event.description, event.date, event.end_date, event.group, event.row_start, event.row_end,
      event.id, event.state, event.row_start, duration, startClass, lengthClass, groupDetails, event.comments,
      uploads, event.label, event.label_color, event.label_title, event.is_private, event.recurrences,
      event.recurrences_start);
  }

  // todo: refactor with above
  static fromEvent(event: BackendEvent): ViewEvent {

    const details = event.group_details;
    const groupDetails = new GroupDetails(details['id'], details['name'], details['display_name'],
      details['school'], details['year']);
    const viewEvent: ViewEvent = ViewEvent.fromBackendEvent(event, groupDetails);
    return viewEvent;
  }

  static fromJson(obj: any) {
    return new ViewEvent(obj['title'], obj['description'], obj['date'], obj['end_date'], obj['group'],
      obj['row_start'], obj['row_end'], obj['id'], obj['state'], obj['start'], obj['duration'], obj['startClass'],
      obj['lengthClass'], obj['groupDetails'], obj['comments'], obj['uploads'], obj['label'], obj['labelColor'],
      obj['labelTitle'], obj['private'], obj['recurrences'], obj['recurrences_start']);
  }

  deepClone() {
    return cloneDeep(this);
  }

  isInitialized(): boolean {
    return this.id !== ViewEvent.INVALID_ID;
  }

  countComments(): number {
    return this.comments ? this.comments.length : 0;
  }

  displayCommentCount(): boolean {
    return this.countComments() > 0;
  }

  addUpload(attachment: FileAttachment): void {
    this.uploads = this.uploads.concat(attachment);
  }

  removeUpload(id: number): void {
    this.uploads = this.uploads.filter(upload => upload['id'] !== id);
  }

  isRecurring(): boolean {
    return this.recurrences != null
  }

}

export interface SlotIndexes {
  numEvents: number;
  eventIds: number[];
  displayId: number;
  displayIndex: number;
}
